'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDataflowAttributes = undefined;
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
var _constants = require('./constants');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var getDataflowAttributes = exports.getDataflowAttributes = function getDataflowAttributes(attributes, combinations) {
  var combinationsConceptsIds = R.pipe(R.pluck('concepts'), R.unnest)(combinations);
  return R.reduce(function (acc, attribute) {
    if (!R.prop('header', attribute) || !R.isEmpty(attribute.relationship) || R.includes(attribute.id, combinationsConceptsIds)) {
      return acc;
    }
    var value = R.head(attribute.values);
    if (!R.propOr(true, 'display', attribute) || R.isNil(value) || !R.propOr(true, 'display', value) || R.includes(R.prop('id', value), _constants.REJECTED_VALUE_IDS)) {
      return acc;
    }
    return R.assoc(attribute.id, (0, _extends3.default)({}, R.pick(['id', 'name'], attribute), {
      value: value
    }), acc);
  }, {}, attributes);
};